export default __webpack_public_path__ + "static/media/img_shouye_jishu_02.711d472f.png";